import { ContaBancaria, EmendaParlamentarRecursoAdicional, Favorecido, Orgao, Parlamentares, Recurso } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { EmendaParlamentarCronograma } from './emenda-parlamentar-cronograma.model';

export class EmendaParlamentar extends BaseResourceModel {
  constructor(
    public id?: number,
    public recurso?: Recurso,
    public parlamentar?: Parlamentares,
    public favorecido?: Favorecido,
    public conta?: ContaBancaria,
    public orgao?: Orgao,
    public objeto?: string,
    public observacao?: string,
    public data_atuacao?: Date,
    public assunto?: string,
    public valor_autorizado?: number,
    public valor_empenhado?: number,
    public valor_liquidado?: number,
    public valor_recebido?: number,
    public valor_executado?: number,
    public classificacao_emenda?: 'IMPOSITIVA' | 'NAO_IMPOSITIVA',
    public destinacao_emenda?: 'CUSTEIO' | 'INVESTIMENTO',
    public fundamento_legal?: 'LEI' | 'RESOLUCAO' | 'DECRETO' | 'PORTARIA',
    public ano_emenda?: number,
    public cronogramas?: EmendaParlamentarCronograma[],
    public recursos_adicionais?: EmendaParlamentarRecursoAdicional[],
    public arquivos?: any[],

  ) {
    super();
  }

  static converteJson(json: any): EmendaParlamentar {
    return Object.assign(new EmendaParlamentar(), json);
  }
}
